(function($) {
Drupal.behaviors.scripts = {
  attach: function (context, settings) {
    // Add print action to print link
    $('.icon--print').click(function(){
     window.print();
    });
    // END
    //Resize iframe height

    var iframe = $(".field--name-field-iframe  iframe")[0];
    $(iframe).ready(function (event) {
      var height = $(this).find("html").height() + 500 ;
      $(iframe).height(height);
      $(iframe).height(height);
    });
            //END
    // radiobuttonstyle
    $(window).on('load', function () {
      $('.js-webform-radios input:checked').each(function()  {
        $(this).parent('.form-item').addClass('selected');
      });
    });
    $('.js-webform-radios input').change(function() {
       $(this).parent('.form-item').siblings().removeClass('selected');
       $(this).parent('.form-item').addClass('selected');
    });

    // END
  }
};
})(jQuery);
